module.exports = __webpack_public_path__ + "static/assets/a9fb808a8b7994a8f00429a15df44a73.png";